// Koop ongedaan maken: the two steps on top of the one plain form of main-withdrawal.liquid.
// Without JavaScript the page is one form with a required confirmation box, so it works as it is. Here: the box and
// its button go away, "Verder naar controleren" checks step 1 (errors under each field in the page's language,
// aria-invalid, aria-describedby, focus to the first one, a count in the live region), step 2 shows the summary and
// the button "Herroeping bevestigen", which writes the declaration with the time of sending into the body and keeps
// a copy in sessionStorage. After Shopify's redirect (?contact_posted=true) the receipt is filled from that copy.
// Focus goes to each step's heading; the print buttons print only the receipt or only the model form.
const root = document.querySelector('[data-wd]');
const KEY = 'aq-withdrawal';
const KEEP = 6 * 60 * 60 * 1000;

if (root) {
  const msg = (key) => root.dataset[key] || '';
  const label = (key) => root.dataset[`label${key[0].toUpperCase()}${key.slice(1)}`] || key;
  const lang = (document.documentElement.lang || 'nl').toLowerCase().startsWith('nl') ? 'nl-NL' : 'en-GB';
  const calm = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('is-motion-paused');

  // "18 oktober 2026 om 14:32" in Dutch time, the shop's time zone (also that of BE, DE and FR).
  const when = (date) => {
    try {
      const day = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Amsterdam' }).format(date);
      const time = new Intl.DateTimeFormat(lang, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Amsterdam' }).format(date);
      return msg('msgWhen').replace('[date]', day).replace('[time]', time);
    } catch {
      return date.toISOString();
    }
  };
  // A date field's value (yyyy-mm-dd) written out, at noon so no time zone moves it to another day.
  const longDate = (value) => {
    try {
      return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${value}T12:00:00`));
    } catch {
      return value;
    }
  };

  // ---- printing: only the receipt or only the model form (CSS reads html[data-wd-print])
  const html = document.documentElement;
  const model = root.querySelector('[data-wd-model]');
  let printDefault = '';
  const printOnly = (kind) => {
    const wasOpen = model?.open;
    if (kind === 'model' && model) model.open = true;
    html.dataset.wdPrint = kind;
    const reset = () => {
      if (printDefault) html.dataset.wdPrint = printDefault;
      else delete html.dataset.wdPrint;
      if (kind === 'model' && model && !wasOpen) model.open = false;
      removeEventListener('afterprint', reset);
    };
    addEventListener('afterprint', reset);
    window.print();
  };
  root.querySelectorAll('[data-wd-print]').forEach((btn) => {
    btn.hidden = false;
    btn.addEventListener('click', () => printOnly(btn.dataset.wdPrint));
  });

  const done = root.querySelector('[data-wd-done]');
  if (done) receipt(done);
  else steps();

  // ---- the receipt after Shopify's redirect
  function receipt(box) {
    printDefault = 'done';
    html.dataset.wdPrint = 'done';
    let data = null;
    try {
      data = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch {
      data = null;
    }
    if (data && Date.now() - data.t < KEEP) {
      const put = (key, value) => {
        const out = box.querySelector(`[data-wd-out="${key}"]`);
        const row = box.querySelector(`[data-wd-row="${key}"]`);
        if (!out || !value) return;
        out.textContent = value;
        if (row) row.hidden = false;
      };
      put('order', data.order);
      put('items', data.items);
      put('email', data.email);
      put('when', data.when);
      const mail = box.querySelector('[data-wd-out="mail"]');
      if (mail && data.email) mail.textContent = msg('msgDoneMail').replace('[email]', data.email);
    }
    // The heading is #contact_form, Shopify's redirect target: the header scrolls it under the bar and focuses it on
    // load. Without that hash (or the header), focus it here.
    const title = box.querySelector('[data-wd-done-title]');
    const settle = () => {
      if (!title || document.activeElement === title) return;
      if (location.hash !== `#${title.id}`) title.scrollIntoView({ block: 'center', behavior: 'auto' });
      title.focus({ preventScroll: true });
    };
    if (document.readyState === 'complete') settle();
    else addEventListener('load', () => requestAnimationFrame(() => requestAnimationFrame(settle)), { once: true });
  }

  // ---- the two steps
  function steps() {
    // Only the theme's own form: an app's form in the panel (app mode) is left alone.
    const form = root.querySelector('form.wd-form');
    if (!form) return;
    form.noValidate = true;
    const $ = (sel) => form.querySelector(sel);
    const panels = [...form.querySelectorAll('[data-wd-step]')];
    const stepper = $('[data-wd-steps]');
    const live = $('[data-wd-live]');
    const field = (key) => $(`[data-wd-key="${key}"]`);
    let step = 1;
    let sending = false;

    // The no-JS confirmation (box and button) is replaced by step 2.
    const nojs = $('[data-wd-nojs]');
    if (nojs) {
      nojs.hidden = true;
      nojs.querySelectorAll('input, button').forEach((el) => (el.disabled = true));
    }
    $('[data-wd-js]').hidden = false;
    if (stepper) stepper.hidden = false;

    // Whole order or part of it: the products field only for a part, and then it is required.
    const itemsBox = $('[data-wd-items]');
    const itemsInput = field('items');
    const scope = () => $('[data-wd-scope]:checked')?.dataset.wdScope || 'all';
    const syncScope = () => {
      const part = scope() === 'part';
      itemsBox.hidden = !part;
      itemsInput.required = part;
      if (!part) show(itemsInput, '');
    };
    form.querySelectorAll('[data-wd-scope]').forEach((el) => el.addEventListener('change', syncScope));
    syncScope();

    // Signed in: pick one of the recent orders; the order number field follows, and typing in it moves the choice.
    const pick = $('[data-wd-pick]');
    const orderInput = field('order');
    if (pick) {
      const account = $('[data-wd-account]');
      const itemsHint = $('[data-wd-pick-items]');
      account.hidden = false;
      const hint = () => {
        const items = pick.selectedOptions[0]?.dataset.items || '';
        itemsHint.textContent = items ? msg('msgOrderItems').replace('[items]', items) : '';
        itemsHint.hidden = !items;
      };
      pick.addEventListener('change', () => {
        if (pick.value) {
          orderInput.value = pick.value;
          show(orderInput, '');
        } else {
          orderInput.value = '';
          orderInput.focus();
        }
        hint();
      });
      orderInput.addEventListener('input', () => {
        const match = [...pick.options].find((o) => o.value && o.value === orderInput.value.trim());
        pick.value = match ? match.value : '';
        hint();
      });
      hint();
    }

    // ---- errors in the theme's own style, as on the contact form
    const errorFor = (el) => {
      const value = el.value.trim();
      if (el.type === 'date') return value && el.max && value > el.max ? msg('msgDate') : '';
      if (el.required && !value) return msg(el.dataset.wdMsg);
      if (el.type === 'email' && value && el.validity.typeMismatch) return msg('msgEmailFormat');
      return '';
    };

    function show(el, text) {
      const id = `${el.id}-error`;
      let line = document.getElementById(id);
      const ids = new Set((el.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
      if (!text) {
        line?.remove();
        el.removeAttribute('aria-invalid');
        ids.delete(id);
      } else {
        if (!line) {
          line = document.createElement('p');
          line.className = 'error wd-error';
          line.id = id;
          el.after(line);
        }
        line.textContent = text;
        el.setAttribute('aria-invalid', 'true');
        ids.add(id);
      }
      if (ids.size) el.setAttribute('aria-describedby', [...ids].join(' '));
      else el.removeAttribute('aria-describedby');
    }

    const say = (text) => {
      live.textContent = '';
      // A new text node in the next frame, so the same sentence twice is still read.
      requestAnimationFrame(() => (live.textContent = text));
    };

    const checkStep1 = () => {
      const bad = [];
      for (const el of form.querySelectorAll('[data-wd-step="1"] [data-wd-check]')) {
        if (el.closest('[hidden]')) continue;
        const text = errorFor(el);
        show(el, text);
        if (text) bad.push(el);
      }
      return bad;
    };

    const go = (n) => {
      step = n;
      panels.forEach((p) => (p.hidden = Number(p.dataset.wdStep) !== n));
      stepper?.querySelectorAll('[data-wd-steps-item]').forEach((li) => {
        const i = Number(li.dataset.wdStepsItem);
        li.classList.toggle('is-current', i === n);
        li.classList.toggle('is-done', i < n);
        if (i === n) li.setAttribute('aria-current', 'step');
        else li.removeAttribute('aria-current');
      });
      const panel = form.closest('.wd-panel') || form;
      const top = panel.getBoundingClientRect().top;
      if (top < 0 || top > innerHeight * 0.4) panel.scrollIntoView({ block: 'start', behavior: calm() ? 'auto' : 'smooth' });
      $(`[data-wd-step="${n}"] .wd-step__title`)?.focus({ preventScroll: true });
      say(msg(n === 2 ? 'msgStep2' : 'msgStep1'));
    };

    // What the visitor filled in, in their words, for the review, the e-mail body and the receipt.
    const collect = () => {
      const value = (key) => field(key)?.value.trim() || '';
      const pickItems = pick && pick.value && pick.value === value('order') ? pick.selectedOptions[0]?.dataset.items || '' : '';
      const items = scope() === 'part' ? value('items') : pickItems ? `${msg('msgWhole')}: ${pickItems}` : msg('msgWhole');
      return {
        name: value('name'),
        email: value('email'),
        order: value('order'),
        items,
        received: value('received') ? longDate(value('received')) : '',
        note: value('note'),
      };
    };

    const review = () => {
      const data = collect();
      for (const [key, text] of Object.entries(data)) {
        const out = $(`[data-wd-show="${key}"]`);
        if (out) out.textContent = text || msg('msgNotGiven');
      }
      const noteRow = $('[data-wd-show-row="note"]');
      if (noteRow) noteRow.hidden = !data.note;
    };

    const next = () => {
      const bad = checkStep1();
      if (bad.length) {
        const first = bad[0];
        const box = first.closest('.field') || first;
        box.scrollIntoView({ block: 'center', behavior: calm() ? 'auto' : 'smooth' });
        first.focus({ preventScroll: true });
        say(bad.length === 1 ? msg('msgErrorsOne') : msg('msgErrorsOther').replace('[count]', bad.length));
        return;
      }
      review();
      go(2);
    };

    $('[data-wd-edit]')?.addEventListener('click', () => go(1));

    form.addEventListener('submit', (event) => {
      if (step === 1) {
        event.preventDefault();
        next();
        return;
      }
      if (sending) {
        event.preventDefault();
        return;
      }
      // Step 2, "Herroeping bevestigen": the declaration with the time of sending goes into the body.
      const now = new Date();
      const data = collect();
      const sent = when(now);
      const lines = [
        msg('msgDeclIntro'),
        msg('msgDeclText'),
        '',
        `${label('name')}: ${data.name}`,
        `${label('email')}: ${data.email}`,
        `${label('order')}: ${data.order}`,
        `${label('items')}: ${data.items}`,
        `${label('received')}: ${data.received || msg('msgNotGiven')}`,
      ];
      if (data.note) lines.push(`${label('note')}: ${data.note}`);
      lines.push(`${msg('msgDeclSent')}: ${sent} (${now.toISOString()})`);
      $('[data-wd-body]').value = lines.join('\n');
      const stamp = $('[data-wd-stamp]');
      stamp.disabled = false;
      stamp.value = `${sent} (${now.toISOString()})`;
      $('[data-wd-confirmed]').disabled = false;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ t: now.getTime(), order: data.order, items: data.items, email: data.email, when: sent }));
      } catch {
        /* private mode: the receipt shows the server's time instead */
      }
      sending = true;
      const btn = $('[data-wd-confirm]');
      btn.setAttribute('aria-busy', 'true');
      btn.dataset.state = 'busy';
      say(msg('msgBusy'));
    });

    // A marked field loses its line as soon as it is right.
    form.addEventListener('input', (event) => {
      const el = event.target;
      if (el.getAttribute('aria-invalid') === 'true' && !errorFor(el)) show(el, '');
    });

    // Back from Shopify's spam check or with the back button (page from the back-forward cache): ready to send again.
    addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      sending = false;
      const btn = $('[data-wd-confirm]');
      btn.removeAttribute('aria-busy');
      delete btn.dataset.state;
    });
  }
}
